// src/stores/customerStore.js
import { defineStore } from "pinia";
import { customerService } from "@/services/customerService";
import { useAppStore } from "@/stores/appStore";
import { toast } from 'vue3-toastify';

export const useCustomerStore = defineStore("customerStore", {
  state: () => ({
    customers: [],
    customer: [],
    services: [],
  }),

  actions: {
    async getAllCustomers() {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await customerService.fetchAllCustomers();
        this.customers = response.data;
      } catch (error) {
        toast.error(error.response.data.message + ' - 2001');
      } finally {
        appStore.setLoading(false);
      }
    },

    async getCustomer(id) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await customerService.fetchCustomer(id);
        this.customer = response.data;
        return this.customer;
      } catch (error) {
        toast.error(error.response.data.message + ' - 2002');
      } finally {
        appStore.setLoading(false);
      }
    },

    async createCustomer(userData) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await customerService.fetchCreateCustomer(userData);
        this.customers.push(response.data);
      } finally {
        appStore.setLoading(false);
      }
    },

    async updateCustomer(id, userData) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await customerService.fetchUpdateCustomer(id, userData);
        const index = this.customers.findIndex(b => b.id === id);
        if (index !== -1) {
          this.customers.splice(index, 1, response.data);
        }
      } finally {
        appStore.setLoading(false);
      }
    },

    async deleteCustomer(id) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        await customerervice.fetchDeleteCustomer(id);
        this.customers = this.customers.filter(b => b.id !== id);
        toast.success("Success");
      } catch (error) {
        toast.error(error.response.data.message + ' - 2003');
      } finally {
        appStore.setLoading(false);
      }
    },

    async getCustomerSearch(userData) {
      const appStore = useAppStore();
      appStore.setLoading(true);
      try {
        const response = await customerService.fetchCustomerSearch(userData);
        this.customers = response.data;
        return this.customers;
      } catch (error) {
        toast.error(error.response.data.message + ' - 2002');
      } finally {
        appStore.setLoading(false);
      }
    },

    async getCustomerService(id) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await customerService.fetchCustomerService(id);
        this.services = response.data;
      } catch (error) {
        toast.error(error.response.data.message + ' - 2002');
      } finally {
        appStore.setLoading(false);
      }
    },
  },
});
